import React, { useEffect, useState } from "react";

// npm install reactstrap
import { Col, Button, Form, FormGroup, Label, Input } from "reactstrap";

// npm install axios
import axios from "axios";

const App = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [posts, setPosts] = useState([]);
  const [meals, setMeals] = useState([]);

  //console.log( JSON.stringify({ email: email, password: password }) );
  //console.log( { email, password } );

  // https://www.marchouben.nl/php/inloggegevens-post.php
  const submitPost = () => {
    axios({
      method: "POST",
      url: "https://www.marchouben.nl/php/inloggegevens-post.php",
      headers: {
        //"Content-Type": "application/json",
        "Content-Type": "text/plain", // To prevent preflight, change application/json into text/plain
      },
      //data: {
      //  email,
      //  password,
      //},
      data: JSON.stringify({ email: email, password: password }),
    })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
/*
    axios
      .get(`https://www.marchouben.nl/php/inloggegevens-get.php`)
      .then((response) => {
        //console.log(response.data[0].username);
        //console.log(response.data[17].password);
        console.log(response.data);
        setPosts(response.data);
      });
*/      
  };

  // https://www.marchouben.nl/php/inloggegevens-get.php
  useEffect(() => {
    axios
      .get(`https://www.marchouben.nl/php/inloggegevens-get.php`)
      .then((response) => {
        //console.log(response.data[0].username);
        //console.log(response.data[17].password);
        console.log(response.data);
        setPosts(response.data);
      });

    axios
      .get(`https://www.marchouben.nl/php/maaltijden-get.php`)
      .then((response) => {
        //console.log(response.data[0].naam);
        //console.log(response.data[6].omschrijving);
        console.log(response.data);
        setMeals(response.data);
      });
  }, []);

  if (!posts) return <p>Er zijn geen gegevens gevonden.</p>;

  const postsList = posts.map((post) => (
    <li key={post.id}>
      {post.username} | {post.password}
    </li>
  ));

  if (!meals) return <p>Er zijn geen gegevens gevonden.</p>;

  const mealsList = meals.map((meal) => (
    <li key={meal.id}>
      {meal.naam} | {meal.omschrijving} | {meal.prijs} | {meal.datum}
    </li>
  ));

  return (
    <div>
      <Form>
        <FormGroup row>
          <Label for="exampleEmail" sm={2}>
            Email
          </Label>
          <Col sm={10}>
            <Input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              name="email"
              placeholder="email"
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label for="examplePassword" sm={2}>
            Password
          </Label>
          <Col sm={10}>
            <Input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              name="password"
              placeholder="password"
            />
          </Col>
        </FormGroup>

        <FormGroup check row>
          <Col sm={{ size: 10, offset: 2 }}>
            <Button onClick={submitPost}>Submit POST</Button>
          </Col>
        </FormGroup>
      </Form>
      {/*
      <div>
        <h1>{post.username}</h1>
        <p>{post.password}</p>
      </div>
*/}
      <h2>Inloggegevens</h2>
      <div>{postsList}</div>
      <h2>Maaltijden</h2>
      <div>{mealsList}</div>
    </div>
  );
};

export default App;

/*
// npm install axios
import axios from "axios";
import classes from "./App.module.css";
import { useEffect } from "react";
//import { useRef } from "react";

// https://jasonwatmore.com/post/2020/07/17/react-axios-http-post-request-examples
function App() {
  useEffect(() => {
    // POST request using axios inside useEffect React hook
    const article = { title: "React Hooks POST Request Example" };
    axios
      .post("https://www.marchouben.nl/php/axios.php", article)
      .then((response) => console.log(response.data.id));

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);

  //const API_PATH = "https://www.marchouben.nl/php/axios.php";
  /*
  const authorInputRef = useRef();
  const textInputRef = useRef();

  function handleFormSubmit(e) {
    e.preventDefault();

const usersName = JSON.stringify({ name: 'John Doe' });
const customConfig = {
    headers: {
    'Content-Type': 'application/json'
    }
};
const result = axios.post(
  "https://www.marchouben.nl/php/axios.php",
  usersName,
  customConfig
);

console.log(result.data.data); // '{"name":"John Doe"}'
console.log(result.data.headers['Content-Type']); // 'application/json',
*/
/*    
    const enteredAuthor = authorInputRef.current.value;
    const enteredText = textInputRef.current.value;

    console.log(JSON.stringify({ author: enteredAuthor, text: enteredText }));

    axios({
      method: "post",
      url: `${API_PATH}`,
      //mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
        //"Access-Control-Allow-Origin": '*', //process.env.REACT_APP_API_URL,
        //"Access-Control-Request-Headers": "Content-Type, Authorization",
      },
      data: JSON.stringify({ author: enteredAuthor, text: enteredText }),
    })
      .then((result) => console.log(result))
      .catch((error) => console.log(error.message));
*/
// };

// onSubmit={handleFormSubmit}
/*
  return (
    <form className={classes.form}>
      <div className={classes.control}>
        <label htmlFor="author">Author</label>
        <input
          type="text"
          id="author"
          //ref={authorInputRef}
          name="author"
        />
      </div>
      <div className={classes.control}>
        <label htmlFor="text">Text</label>
        <textarea
          id="text"
          rows="5"
          //ref={textInputRef}
          name="text"
        ></textarea>
      </div>
      <div className={classes.actions}>
        <button className="btn">Verzenden</button>
      </div>
    </form>
  );
}

export default App;
*/
